import { X } from 'lucide-react';

const variants = {
  success: 'bg-success-500/10 border-success-500/30 text-success-700',
  danger: 'bg-danger-500/10 border-danger-500/30 text-danger-700',
  warning: 'bg-warning-500/10 border-warning-500/30 text-warning-700',
  info: 'bg-info-500/10 border-info-500/30 text-info-700',
};

const Alert = ({ variant = 'info', children, onDismiss, className = '' }) => (
  <div
    role="alert"
    className={`flex items-start gap-3 rounded border px-4 py-3 text-base ${variants[variant] ?? variants.info} ${className}`}
  >
    <div className="flex-1">{children}</div>
    {onDismiss && (
      <button type="button" onClick={onDismiss} aria-label="Dismiss" className="shrink-0 opacity-70 hover:opacity-100">
        <X className="w-4 h-4" />
      </button>
    )}
  </div>
);

export default Alert;
